import PropTypes from 'prop-types';

import {
  ButtonContentItemFullWidth,
  ButtonContentItemPrimary,
  ButtonContentItemSecondary,
  ButtonContentItemTertiary
} from '#client/components/Grid/ActionButtonsGrid.style';

import { ACTION_BUTTON_TYPE } from './constants';

export const ButtonWrapper = ({ type = ACTION_BUTTON_TYPE.PRIMARY, children }) => {
  switch (type) {
    case ACTION_BUTTON_TYPE.SECONDARY:
      return <ButtonContentItemSecondary>{children}</ButtonContentItemSecondary>;
    case ACTION_BUTTON_TYPE.FULL_WIDTH:
      return <ButtonContentItemFullWidth>{children}</ButtonContentItemFullWidth>;
    case ACTION_BUTTON_TYPE.TERTIARY:
      return <ButtonContentItemTertiary>{children}</ButtonContentItemTertiary>;
    case ACTION_BUTTON_TYPE.PRIMARY:
    default:
      return <ButtonContentItemPrimary>{children}</ButtonContentItemPrimary>;
  }
};

ButtonWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf([...Object.values(ACTION_BUTTON_TYPE)])
};
